<template>
	<div id="app">
		<HomeView />
	</div>
</template>

<script>
import HomeView from "./components/HomeView.vue";

export default {
	name: "App",
	components: {
		HomeView,
	},
	async mounted() {
		const url = "https://squarim-f5ljwmnzga-ew.a.run.app/";
		const response = await fetch(url);
		if (response.status == 200) {
			console.log("Server is up and running");
		}
	},
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");
body {
	margin: 0px;
	font-family: Roboto;
	font-weight: 500;
}

#app {
	font-family: Roboto, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
</style>
